import { QuoteDispositionsService } from "@common/client"
import { makeAxiosMutation, makeNoArgsQuery } from "../utils"

export const dispositionsBaseKey = ["quote-dispositions"] as const

export const dispositionsQuery = makeNoArgsQuery({
  serviceCall: QuoteDispositionsService.listQuoteDispositions,
  queryKey: dispositionsBaseKey,
})

export const useUpdateDispositionMutation = makeAxiosMutation({
  serviceCall: QuoteDispositionsService.update,
  invalidates: () => [dispositionsBaseKey],
})
